<script setup lang="ts">
const { t } = useI18n({ useScope: "local" });
const props = defineProps<{ id: string }>();

const { field } = useInlineBlockEditor(props.id);

const columnsSettings = field<Record<string, number>>("columnsSettings", { default: 1 });
const showErrorSummary = field<boolean>("showErrorSummary", false);
const errorSummaryTitle = field<string>("errorSummaryTitle", "Please fix the errors below");

const sliderModel = computed({
  get: () => [columnsSettings.value?.default ?? 1],
  set: (value: number[]) => {
    columnsSettings.value = {
      ...(columnsSettings.value ?? {}),
      default: value[0] ?? 1,
    };
  },
});
</script>

<template>
  <EditorSection :title="t('title')" icon="lucide:clipboard-list" accent="container">
    <EditorField :label="t('columnsLabel')" :hint="t('columnsHint')">
      <div class="flex items-center gap-3">
        <Slider v-model="sliderModel" :min="1" :max="12" :step="1" class="flex-1" />
        <span class="w-8 text-right font-mono text-[12.5px] text-muted-foreground">
          {{ columnsSettings?.default ?? 1 }}
        </span>
      </div>
    </EditorField>

    <EditorField :label="t('summaryLabel')">
      <div class="flex items-center justify-between">
        <span class="text-[12.5px] text-muted-foreground">{{ t("summaryHint") }}</span>
        <Switch v-model="showErrorSummary" />
      </div>
    </EditorField>

    <EditorField v-if="showErrorSummary" :label="t('summaryTitleLabel')">
      <Input v-model="errorSummaryTitle" class="h-8 rounded-sm bg-muted text-[13px]" />
    </EditorField>
  </EditorSection>
</template>

<i18n lang="yaml">
en:
  title: "Form"
  columnsLabel: "Columns"
  columnsHint: "Set the default number of form columns."
  summaryLabel: "Show Error Summary"
  summaryHint: "Display validation errors at the top of the form."
  summaryTitleLabel: "Summary Title"
</i18n>
